import React from 'react';
import loadable from '@loadable/component';
import { useCalendlyModal } from '@/hooks/useModal';
import Layout from '../components/projects/Layout';

const PricingPlans = loadable(
  () => import('../components/projects/PricingPlan'),
);
const Actions = loadable(() => import('../components/projects/Actions'));

const Faq = loadable(() => import('../components/projects/Faq'));
const HeroBanner = loadable(() => import('../components/projects/HeroBanner'));
const IntroducingCompany = loadable(
  () => import('../components/projects/IntroducingCompany'),
);
const News = loadable(() => import('../components/projects/News'));
const Outcome = loadable(() => import('../components/projects/Outcome'));
const Solution = loadable(() => import('../components/projects/Solution'));
const What = loadable(() => import('../components/projects/What'));
const WhyRicoh = loadable(() => import('../components/projects/WhyRicoh'));

const IndexPage: React.FC = () => {
  const [isOpen, { toggleModal }] = useCalendlyModal();
  return (
    <Layout>
      <HeroBanner
        updateCalendlyModalIsOpen={toggleModal}
        calendlyModalIsOpen={isOpen}
      />
      <What />
      <Outcome />
      <Solution />
      <IntroducingCompany />
      <Actions
        updateCalendlyModalIsOpen={toggleModal}
        calendlyModalIsOpen={isOpen}
      />
      <WhyRicoh />
      <PricingPlans updateCalendlyModalIsOpen={toggleModal} />
      <News />
      <Faq />
      <Actions
        updateCalendlyModalIsOpen={toggleModal}
        calendlyModalIsOpen={isOpen}
      />
    </Layout>
  );
};

export default IndexPage;
